export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";